module.exports = __webpack_public_path__ + "img/portrait-squint.0163a5c2.svg";